var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-block_wrapper_size"},[_c('h2',[_vm._t("title")],2),_vm._t("subtitle"),_c('br'),_vm._t("body")],2)}
var staticRenderFns = []

export { render, staticRenderFns }